// The PostHog group the quote flow keys its flags and events to. Lives
// apart from the flags hook because the app registers the group at
// PostHog init — before the router has rendered anything — so the very
// first flags request is already quote-keyed.

export const QUOTE_GROUP_TYPE = "quote";

/** Mirrors the router's `quotes/:quoteId` route. */
const QUOTE_PATH = /^\/quotes\/([^/?#]+)/;

/** The quote id a URL path names, or null anywhere off the quote flow.
 * Decodes the segment the way the router does for `useParams`, falling
 * back to the raw segment on a malformed escape — this runs inside
 * PostHog's init callback, where a throw would silently skip grouping. */
export function quoteIdFromPath(pathname: string): string | null {
  const match = QUOTE_PATH.exec(pathname);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}
